import {BillingSummary} from "@/domain/BillingAccountSummary";
import {Money} from "@/component/style/Money";
import React, {ReactNode} from "react";
import {Link} from "react-router-dom";
import {Device} from "@/store/Device";
import {NumberTable} from "@/component/style/NumberTable";

/**
 * 이월, 입금, 출금, 잔액을 표시하는 전체 계정 테이블
 */
export function FullAccountTable(props: { children: ReactNode }) {
    return (
        <NumberTable className={Device.isMobile ? 'mobile' : 'pc'}>
            <thead>
            <tr style={{backgroundColor: 'primary.main'}}>
                <th>계정</th>
                {Device.isMobile ?
                    (<>
                        <th align="right">입출금</th>
                    </>)
                    :
                    (<>
                        <th align="right">이월</th>
                        <th align="right">입금</th>
                        <th align="right">출금</th>
                    </>)}
                <th align="right">잔액</th>
            </tr>
            </thead>
            <tbody>{props.children}</tbody>
        </NumberTable>
    );
}

export function FullAccountTableAccountRow(props: {
    name: string;
    href?: string;
    amounts: BillingSummary;
}) {
    const {amounts} = props;
    return (
        <tr>
            <td>
                {props.href ? (
                    <Link to={props.href} color="inherit">{props.name}</Link>
                ) : (
                    props.name
                )}
            </td>
            {Device.isMobile ?
                (
                    <td align="right"><Money amount={amounts.inAmount - amounts.outAmount}/></td>
                ) :
                (<>
                    <td align="right"><Money amount={amounts.carry}/></td>
                    <td align="right"><Money amount={amounts.inAmount}/></td>
                    <td align="right"><Money amount={amounts.outAmount}/></td>
                </>)
            }
            <td align="right"><Money amount={amounts.balance}/></td>
        </tr>
    );
}

export function FullAccountTableTotalRow(props: {
    name: string;
    amounts: BillingSummary;
    className: 'sub-total' | 'total';
}) {
    const {amounts} = props;
    return (
        <tr className={props.className}>
            <td>{props.name}</td>

            {Device.isMobile ?
                (
                    <td align="right"><Money amount={amounts.inAmount - amounts.outAmount}/></td>
                ) :
                (<>
                    <td align="right"><Money amount={amounts.carry}/></td>
                    <td align="right"><Money amount={amounts.inAmount}/></td>
                    <td align="right"><Money amount={amounts.outAmount}/></td>
                </>)
            }
            <td align="right"><Money amount={amounts.balance}/></td>
        </tr>
    );
}
